"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _Box = _interopRequireDefault(require("../Box"));

var _Card = _interopRequireDefault(require("../Card"));

var _IconButton = _interopRequireDefault(require("../IconButton"));

var _Typography = require("../Typography");

var _Stack = _interopRequireDefault(require("../Stack"));

var _util = require("../../theme/util");

var _Overlay = _interopRequireDefault(require("../Overlay"));

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj["default"] = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var duration = 200;

var CloseIcon = function CloseIcon(_ref) {
  var props = _extends({}, _ref);

  return _react["default"].createElement("svg", _extends({
    "aria-hidden": "true",
    focusable: "false",
    role: "img",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 352 512",
    style: {
      fontSize: "inherit",
      height: "1em",
      width: '1em',
      verticalAlign: '-0.125em'
    }
  }, props), _react["default"].createElement("path", {
    fill: "currentColor",
    d: "M242.72 256l100.07-100.07c12.28-12.28 12.28-32.19 0-44.48l-22.24-22.24c-12.28-12.28-32.19-12.28-44.48 0L176 189.28 75.93 89.21c-12.28-12.28-32.19-12.28-44.48 0L9.21 111.45c-12.28 12.28-12.28 32.19 0 44.48L109.28 256 9.21 356.07c-12.28 12.28-12.28 32.19 0 44.48l22.24 22.24c12.28 12.28 32.2 12.28 44.48 0L176 322.72l100.07 100.07c12.28 12.28 32.2 12.28 44.48 0l22.24-22.24c12.28-12.28 12.28-32.19 0-44.48L242.72 256z"
  }));
};

var enterAnim = (0, _styledComponents.keyframes)(["0%{opacity:0;transform:translateY(60px) scale(0.8);}100%{opacity:1;transform:translateY(0) scale(1);}"]);
var exitAnim = (0, _styledComponents.keyframes)(["0%{opacity:1;transform:translateY(0) scale(1);}100%{opacity:0;transform:translateY(60px) scale(0.8);}"]);
var DialogEl = (0, _styledComponents["default"])(_Card["default"]).withConfig({
  displayName: "Dialog__DialogEl",
  componentId: "oka4ed-0"
})(["&[data-anim=entering],&[data-anim=entered]{animation:", " ", "ms ", " both;}&[data-anim=exiting]{animation:", " ", "ms ", " both;}"], enterAnim, duration, _util.transition, exitAnim, duration, _util.transition);

var Dialog =
/*#__PURE__*/
function (_React$Component) {
  _inherits(Dialog, _React$Component);

  function Dialog() {
    _classCallCheck(this, Dialog);

    return _possibleConstructorReturn(this, _getPrototypeOf(Dialog).apply(this, arguments));
  }

  _createClass(Dialog, [{
    key: "renderTitle",
    value: function renderTitle(close) {
      var _this$props = this.props,
          title = _this$props.title,
          showClose = _this$props.showClose,
          CloseIcon = _this$props.closeIcon;
      if (title === false) return null;
      var content;

      if (typeof title === 'function') {
        content = title({
          close: close
        });
      } else {
        content = _react["default"].createElement(_Typography.Heading, {
          size: 5
        }, title);
      }

      return _react["default"].createElement(_Box["default"], {
        p: 5,
        flexShrink: 0,
        display: "flex",
        alignItems: "center"
      }, content, showClose && _react["default"].createElement(_react["default"].Fragment, null, _react["default"].createElement(_Box["default"], {
        flex: "1"
      }), _react["default"].createElement(_IconButton["default"], {
        onClick: close
      }, _react["default"].createElement(CloseIcon, null))));
    }
  }, {
    key: "renderChildren",
    value: function renderChildren(close) {
      var children = this.props.children;

      if (typeof children === 'function') {
        return children({
          close: close
        });
      }

      return children;
    }
  }, {
    key: "renderToolbar",
    value: function renderToolbar(close) {
      if (!this.props.toolbar) return null;
      var elements = this.props.toolbar;

      if (typeof this.props.toolbar === 'function') {
        elements = this.props.toolbar({
          close: close
        });
      }

      return _react["default"].createElement(_Box["default"], {
        display: "flex",
        alignItems: "center",
        px: 5,
        py: 3
      }, this.props.toolbarFlexLeft && _react["default"].createElement(_Box["default"], {
        flex: "1"
      }), elements);
    }
  }, {
    key: "render",
    value: function render() {
      var _this = this;

      var _this$props2 = this.props,
          onClose = _this$props2.onClose,
          onBeforeClose = _this$props2.onBeforeClose,
          open = _this$props2.open,
          preventBodyScroll = _this$props2.preventBodyScroll,
          modal = _this$props2.modal,
          contentProps = _this$props2.contentProps,
          minHeight = _this$props2.minHeight,
          width = _this$props2.width,
          bodyProps = _this$props2.bodyProps,
          title = _this$props2.title,
          scroll = _this$props2.scroll,
          props = _objectWithoutProperties(_this$props2, ["onClose", "onBeforeClose", "open", "preventBodyScroll", "modal", "contentProps", "minHeight", "width", "bodyProps", "title", "scroll"]);

      var xOffset = '32px';
      var yOffset = '32px';
      var maxHeight = scroll === 'dialog' ? "calc(100% - ".concat(yOffset, " * 2)") : null;
      return _react["default"].createElement(_Overlay["default"], {
        shown: open,
        onBeforeClose: onBeforeClose,
        preventBodyScroll: preventBodyScroll || scroll === 'body',
        alignItems: scroll === 'body' ? 'flex-start' : 'center',
        shouldCloseOnClick: !modal,
        onExited: onClose
      }, function (_ref2) {
        var state = _ref2.state,
            close = _ref2.close;
        return _react["default"].createElement(_Stack["default"], null, function (zIndex) {
          return _react["default"].createElement(DialogEl, _extends({
            "data-anim": state,
            bg: "white",
            boxShadow: 7,
            borderRadius: "4px",
            mx: xOffset,
            my: yOffset,
            width: width,
            zIndex: zIndex,
            maxHeight: maxHeight,
            display: "flex",
            flexDirection: "column"
          }, props), _this.renderTitle(close), _react["default"].createElement(_Card["default"], _extends({
            minHeight: minHeight,
            px: 5,
            pb: 5,
            pt: _this.props.title ? 0 : 5,
            flex: "1 1 auto",
            overflow: scroll === 'body' ? 'hidden' : 'auto'
          }, contentProps), _this.renderChildren(close)), _this.renderToolbar(close));
        });
      });
    }
  }]);

  return Dialog;
}(_react["default"].Component);

exports["default"] = Dialog;

_defineProperty(Dialog, "propTypes", {
  title: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].node, _propTypes["default"].bool]),
  modal: _propTypes["default"].bool,
  onBeforeClose: _propTypes["default"].func,
  onClose: _propTypes["default"].func,
  open: _propTypes["default"].bool.isRequired,
  contentProps: _propTypes["default"].object,
  minHeight: _propTypes["default"].number,
  preventBodyScroll: _propTypes["default"].bool,
  toolbarFlexLeft: _propTypes["default"].bool,
  scroll: _propTypes["default"].string
});

_defineProperty(Dialog, "defaultProps", {
  minHeight: 80,
  onBeforeClose: function onBeforeClose() {},
  width: 560,
  modal: false,
  title: false,
  scroll: 'dialog',
  preventBodyScroll: false,
  toolbarFlexLeft: true,
  bodyProps: {},
  showClose: true,
  closeIcon: CloseIcon
});